import {IBrowserUtilsService} from '@techsee/techsee-client-infra/lib/services/BrowserUtilsService';

export interface IExpiredController {}

export class ExpiredController implements IExpiredController {
    constructor(private _browserUtilsService: IBrowserUtilsService) {}
}
